/** Tipos de desligamento — espelho de backend/src/types/desligamento.ts. */

export const TIPOS_DE_DESLIGAMENTO = [
  'PEDIDO_DEMISSAO',
  'DISPENSA_SEM_JUSTA_CAUSA',
  'DISPENSA_JUSTA_CAUSA',
  'ACORDO',
  'TERMINO_CONTRATO',
  'APOSENTADORIA',
  'FALECIMENTO',
  'OUTRO',
] as const;
export type TipoDeDesligamento = (typeof TIPOS_DE_DESLIGAMENTO)[number];

export const ROTULO_DESLIGAMENTO: Record<TipoDeDesligamento, string> = {
  PEDIDO_DEMISSAO: 'Pedido de demissão',
  DISPENSA_SEM_JUSTA_CAUSA: 'Dispensa sem justa causa',
  DISPENSA_JUSTA_CAUSA: 'Dispensa por justa causa',
  ACORDO: 'Acordo (Lei 13.467)',
  TERMINO_CONTRATO: 'Término de contrato',
  APOSENTADORIA: 'Aposentadoria',
  FALECIMENTO: 'Falecimento',
  OUTRO: 'Outro',
};

export type NaturezaDoDesligamento = 'VOLUNTARIO' | 'INVOLUNTARIO' | 'OUTROS';

export const ROTULO_NATUREZA: Record<NaturezaDoDesligamento, string> = {
  VOLUNTARIO: 'Voluntário',
  INVOLUNTARIO: 'Involuntário',
  OUTROS: 'Outros',
};
